import { render, staticRenderFns } from "./NivelAlto.vue?vue&type=template&id=7d505e60&scoped=true"
import script from "./NivelAlto.vue?vue&type=script&lang=js"
export * from "./NivelAlto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d505e60",
  null
  
)

export default component.exports